module.exports = __webpack_public_path__ + "img/t3-6.d67326aa.jpg";